/* Kaptive theme scripts */
(function () {
  // Shop grid filters (by product type)
  function initFilters(root) {
    var buttons = root.querySelectorAll('[data-filter]');
    var cards = root.querySelectorAll('[data-type]');
    var count = root.querySelector('[data-count]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-filter');
        var shown = 0;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        cards.forEach(function (card) {
          var match = value === 'all' || card.getAttribute('data-type') === value;
          card.hidden = !match;
          if (match) shown++;
        });
        if (count) count.textContent = shown;
      });
    });
  }

  // Product gallery thumbnails
  function initGallery(root) {
    var main = root.querySelector('[data-main-image]') || root.querySelector('.k-product__main img');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!main) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  }

  // Variant (size) picker: keep the button label and price in sync
  function initVariants(form) {
    var radios = form.querySelectorAll('input[name="id"][type="radio"]');
    var button = form.querySelector('[data-add]');
    var price = document.querySelector('[data-price]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (price && radio.dataset.price) price.innerHTML = radio.dataset.price;
        if (button) {
          var available = radio.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-shop-grid]').forEach(initFilters);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initVariants);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
